import { render, staticRenderFns } from "./TranshipmentTransferDelivererTab.vue?vue&type=template&id=348d51b0"
import script from "./TranshipmentTransferDelivererTab.vue?vue&type=script&lang=js"
export * from "./TranshipmentTransferDelivererTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports